export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/b71ac3d9b536e8fc5eda02acd414eaa4.jpg"
          alt="Immersive Workshop Environment"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      {/* Floating Particles */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white/30 rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h1 className="font-serif text-6xl md:text-7xl lg:text-8xl font-bold mb-6 leading-tight">
          <span className="block text-white drop-shadow-[0_0_30px_rgba(255,255,255,0.3)]">Groove &amp; Glow:</span>
          <span className="block text-white drop-shadow-[0_0_30px_rgba(255,255,255,0.3)]">Elemental Harmony Workshop</span>
        </h1>
        
        <p className="text-cyan-400 text-2xl md:text-3xl font-light tracking-wider mb-8">
          A tech-driven dance and wellness experience designed for modern teams
        </p>

        <p className="text-white/85 text-lg md:text-xl leading-relaxed mb-12 max-w-3xl mx-auto">
          Groove &amp; Glow is a unique, immersive team experience combining movement, wellness and technology. 
          It serves as Singapore's exclusive warm-up experience for the Ultimate Freestyle War competition in Hong Kong — 
          reimagined as a creative, holistic and inclusive corporate workshop. This is not a traditional team building or dance class, 
          but a story-driven, multi-sensory journey suitable for all backgrounds and skill levels.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <a 
            href="#contact" 
            className="px-12 py-4 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-orange-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap inline-flex items-center gap-3"
          >
            Request Workshop Proposal
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
          <a 
            href="#contact" 
            className="px-10 py-4 border-2 border-cyan-400 rounded-full text-cyan-400 font-bold text-lg hover:bg-cyan-400/10 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            Speak to Program Designer
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/60 text-sm">Explore</span>
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}
